/**
 * How a Markdown body finds a picture it names as `attachment:<id>`.
 *
 * The value is a function from a list of ids to a promise of
 * `{ [id]: { url, preview } }`, holding only the ids the reader may see. The
 * signed-in app asks the server for a ticket address; the project link page
 * answers from the files its link already lists. An id left out is drawn as
 * its alt text, so a stored reference never reaches the page.
 *
 * Its own module, imported by the renderer and the editor alike, so the
 * public pages can provide it without importing the signed-in app.
 */

import { createContext } from "react";

export const PicturesContext = createContext(null);
